<template>
    <div>
        <div class="card shadow p-0 m-0">
            <div class="card-header bg-transparent">
                <div>
                    <h3 class="mb-0">
                        {{ $tc('message.add', 2) }} {{ $tc('message.groupes', 2) }} {{ formy }}
                    </h3>
                </div>
            </div>
            <b-container class="p-2">
                <form ref="form" @submit.stop.prevent="handleSubmit"  id="form">
                    <b-row class="mt-1">
                        <b-col sm="2"> <label for="nom">Nom: <span class="text-danger">*</span></label></b-col>
                        <b-col sm="10">
                            <b-form-input id="nom" v-model="form.nom" type="text" placeholder="Entrez le nom du groupe" required></b-form-input>
                        </b-col>
                    </b-row>
                    <b-row class="mt-2">
                        <b-col sm="2"> <label for="users">Utilisateurs: <span class="text-danger">*</span></label></b-col>
                        <b-col sm="10">
                            <b-form-group id="users" for="users">
                                <multiselect v-model="form.users" @select="getUser" :options="list_users" :multiple="true" placeholder="Rechercher les utilisateurs" selectLabel="Rechercher les utilisateurs" label="name" track-by="id" :searchable="true" :loading="loading" :internal-search="false" :clear-on-select="false" :close-on-select="false" :options-limit="30" :max-height="600" :show-no-results="false" :hide-selected="true" @search-change="getSearchPatient"></multiselect>
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <b-row class="mt-2">
                        <b-col sm="2"> <label for="description">Description:</label></b-col>
                        <b-col sm="10">
                            <b-form-textarea id="description" v-model="form.description" type="text" placeholder="Entrez la description"></b-form-textarea>
                        </b-col>
                    </b-row>
                    <b-row class="justify-content-sm-center p-0 m-0">
                        <b-col col sm="12">
                            <div class="text-center">
                                    <b-button variant="success" class="mt-1" type="submit">Soumettre</b-button>
                                </div>
                        </b-col>
                    </b-row>
                </form>
            </b-container>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import Multiselect from 'vue-multiselect'
    import AppConfig from "../../constants/AppConfig";

    export default {
        name: "GroupeCreate",

        components: {
            Multiselect
        },

        computed: {
            ...mapGetters(["subscribers",'hasAdminRole',
                'hasGestionnaireRole',
                'hasPraticienRole',
                'hasMedecinControleRole',
                'hasAssistante',
                'groupe'
            ]),

            can:function(){
                return this.hasAdminRole || this.hasGestionnaireRole || this.hasPraticienRole || this.hasMedecinControleRole || this.hasAssistante;
            },
            
            formy: function () {
                if (this.$route.params.uuid !== undefined) {
                   this.element = this.groupe;
                    console.log(this.element);
                    this.form.nom = this.element.nom;
                    this.form.description = this.element.description;
                    this.form.users = this.element.users;
                    localStorage.setItem('groupeData', JSON.stringify(this.element)); 
                }
                
            }
        },

        data() {
            return {
                list_users: [],
                element: {},
                loading : false,
                form:{
                    nom: "",
                    description: "",
                    users: []
                }
            }
        },
        methods: {
            getUser(user){
                this.loading = false;
            },
            getSearchPatient(user){
                this.loading = true;
                if(user.length > 2){
                    fetch(AppConfig.apiUrl+`/v2/patients-et-souscripteurs?search=${user}`, {headers: {'Authorization': "Bearer " + localStorage.getItem('ms-token')}})
                    .then(res => res.json())
                    .then(res => {
                        this.loading = false;
                        this.list_users = res.data.map(item => ({id: item.id, name: item.name}));
                    }).catch(error => {
                        console.log('error ', error);
                    })
                }else{
                    this.loading = false;
                }
            },
            handleSubmit(){
                let data = {...this.form, uuid: this.$route.params.uuid, users: this.form.users.map(item => item.id)};
                let successMessage = this.$i18n.t('message.groupeCreated');
                let errorMessages = {
                    generic: this.$i18n.t('message.genericError'),
                    error: this.$i18n.t('message.genericError') // TODO: Prendre message approprié
                };

                if (this.$route.params.uuid !== undefined) {
                    this.$store.dispatch('updateGroupe', { args: data, errorMessages, successMessage })
                } else {
                    this.$store.dispatch('createGroupe', { args: data, errorMessages, successMessage })
                }
            
                
            },

            getGroupe: function () {
                let args = {
                    uuid: this.$route.params.uuid
                };
                let errorMessages = {
                    generic: this.$i18n.t('message.genericError'),
                    error: this.$i18n.t('message.genericError') // TODO: Prendre message approprié
                };

                this.$store.dispatch('getGroupe', { args, errorMessages })
            },
        },

        mounted() {
            // console.log(this.groupe);
            if (this.$route.params.uuid !== undefined) {
                const groupeData = localStorage.getItem('groupeData');
                if (groupeData) {
                    // Récupérer les données depuis le localStorage
                    const groupe = JSON.parse(groupeData);
                    // console.log(groupe);
                    this.form.nom = groupe.nom;
                    this.form.description = groupe.description;
                    this.form.users = groupe.users;
                }

                this.getGroupe();
            }
        }
    }
</script>

<style scoped>
    
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>